import i18n from 'modules/core/lib/i18n'

const getIndustryMapping = (): Record<string, string> => ({
  startup: i18n.t('marketplace.revamp.mapping_marketplace_industries.startup'),
  agency: i18n.t('marketplace.revamp.mapping_marketplace_industries.agency'),
  consulting: i18n.t('marketplace.revamp.mapping_marketplace_industries.consulting'),
  technology: i18n.t('marketplace.revamp.mapping_marketplace_industries.technology'),
  communications: i18n.t('marketplace.revamp.mapping_marketplace_industries.communications'),
  construction: i18n.t('marketplace.revamp.mapping_marketplace_industries.construction'),
  engineering: i18n.t('marketplace.revamp.mapping_marketplace_industries.engineering'),
  finance: i18n.t('marketplace.revamp.mapping_marketplace_industries.finance'),
  food_and_beverage: i18n.t('marketplace.revamp.mapping_marketplace_industries.food_and_beverage'),
  media: i18n.t('marketplace.revamp.mapping_marketplace_industries.media'),
  banking: i18n.t('marketplace.revamp.mapping_marketplace_industries.banking'),
  public: i18n.t('marketplace.revamp.mapping_marketplace_industries.public'),
  not_for_profit: i18n.t('marketplace.revamp.mapping_marketplace_industries.not_for_profit'),
  hotels_and_restaurants: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.hotels_and_restaurants'
  ),
  healthcare: i18n.t('marketplace.revamp.mapping_marketplace_industries.healthcare'),
  software_it_services: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.software_it_services'
  ),
  education: i18n.t('marketplace.revamp.mapping_marketplace_industries.education'),
  construction_engineering: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.construction_engineering'
  ),
  commercial_professional_services: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.commercial_professional_services'
  ),
  government_administration: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.government_administration'
  ),
  hospitality: i18n.t('marketplace.revamp.mapping_marketplace_industries.hospitality'),
  food_beverage_tobacco: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.food_beverage_tobacco'
  ),
  retailing: i18n.t('marketplace.revamp.mapping_marketplace_industries.retailing'),
  transportation: i18n.t('marketplace.revamp.mapping_marketplace_industries.transportation'),
  clothing_store: i18n.t('marketplace.revamp.mapping_marketplace_industries.clothing_store'),
  software_management: i18n.t(
    'marketplace.revamp.mapping_marketplace_industries.software_management'
  ),
})

export const getIndustryDisplayName = (industry?: string): string | undefined => {
  if (!industry) return 'null'
  const industryMapping = getIndustryMapping()
  return industryMapping[industry.toLowerCase()]
}
